const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class BorderConflict extends Event {
    constructor(){
        super(
            Age.Age1,
            EventNames.BorderConflict,
            "The weakest civilizations must destroy one of its own urban buildings, farms, or mines. The strongest civilization gains 3 resources",
            {}
        )
    }
}

module.exports = BorderConflict;